<template>
    <div>
        
        <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

        <PageTitle v-bind:title="title" v-bind:admin="false" />


        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>       
        
        <Loader v-if="loading" />
        <div v-else-if="data.question.id">
            <div class="row ml-1 mr-1">
                <div class="col-md-9 ">
                    <p>Курс: <router-link :to="{ name: 'course_show', params: { id: data.course.id } }">{{ data.course.name }}</router-link></p>
                    <p>Глава: <router-link :to="{ name: 'chapter_show', params: { id: data.chapter.id } }">{{ data.chapter.name }}</router-link></p>

                </div>
                <div class="col-md-3  text-center">
                    <img v-if="data.status_id == 5" src="/icons/ok2.png" alt="">
                </div>


            </div>

            <div class="alert alert-success" v-if="data.status_id == 5">
                Вопрос отвечен!
            </div>



            <h3>{{data.question.name}}</h3>

            <div class="shadow p-4 bg-light">
                <p v-html="data.question.text" style="font-weight: bold;"></p>
            </div>

            <h4 class="mt-4 mb-4">Варианты ответа:</h4>
            <div>
                <div class="form-group" v-for="item in data.answers" :key="item.id">
                    <!--   
                        Если вопрос отвечен, то дизейблим чекбоксы, и отображаем правильный ответ, иначе - нет:
                    -->
                    <div class="checkbox">
                        <label>
                            <input v-if="data.status_id == 5" disabled type="checkbox" :name="'answer'+item.id" id="'answer'+item.id" v-model="item.correct">
                            <input v-else                              type="checkbox" :name="'answer'+item.id" id="'answer'+item.id" v-model="item.checked">
                            <i class="fa fa-2x icon-checkbox"></i>
                            {{ item.name }}
                        </label>
                    </div>
                </div>
                <!-- Кнопку "Ответить" показываем только на неотвеченном вопросе: -->
                <button v-if="data.status_id == 1" type="button" class="btn btn-primary" @click.prevent="sendAnswer()">Ответить</button>
                <div class="alert alert-danger" v-if="errors.wrong">
                    {{ errors.wrong }}
                </div>
                <div class="alert alert-danger" v-if="errors.send">
                    {{ errors.send }}
                </div>


            </div>

            <template v-if="data.status_id == 5">
                <span v-if="data.prev_question_id != 0">
                    <router-link class="btn btn-success" title="Перейти к предыдущему вопросу" :to="{ name: 'question_show', params: { id: data.prev_question_id } }"> &larr; Предыдущий вопрос </router-link>
                </span>
                &nbsp;&nbsp;&nbsp;
                <span v-if="data.next_question_id != 0">
                    <router-link class="btn btn-success" title="Перейти к следующему вопросу" :to="{ name: 'question_show', params: { id: data.next_question_id } }"> Следующий вопрос &rarr; </router-link>
                </span>
            </template>
            <p>
                <router-link class="btn btn-info mt-4" :to="{ name: 'questions', params: { id: data.chapter.id } }"> &larr; Вернуться к списку вопросов</router-link>
            </p>


<!--
            <div>
                <br/><br/><br/><br/>
                <h3>-= ДЛЯ ОТЛАДКИ =-</h3>
                <h1>Question SHOW</h1>
                <h3>id: {{data.question.id}}</h3>
                <p>prev: {{data.prev_question_id}}</p>
                <p>next: {{data.next_question_id}}</p>
            </div>
-->

        </div>




    </div>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/Loader'
import BreadCrumbs from '@/components/BreadCrumbs'
import PageTitle from '@/components/PageTitle'
export default {
    data() {
        return {
            loading: true,
            data: [],
            errors: {load: '', send: '', wrong: ''},
            title: 'Тестирование',
            bcrumbs: [],
        }
    },
    async mounted() {
       this.loadData()
    },



    methods: {
        async loadData() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('questions/'+this.$route.params.id)
                this.data = response.data
                this.bcrumbs = response.data.bcrumbs
                for (var i = 0; i < this.data.answers.length; i++) {
                    this.data.answers[i].checked = false;
                }
                this.loading = false
            }
            catch (e) {
                if (e.response.status == 401) {
                    this.errors.load = e.response.data.error
                }
                else {
                    this.errors.load = 'Ошибка при загрузке данных'
                }
            }
        },



        async sendAnswer() {
            this.errors.send = ''
            this.errors.wrong = ''
            try {
                let response = await axios.post('questions/'+this.data.question.id+'/giveAnswer', Object.assign(this.data, {_method: 'PUT'}))
                if (response.status == 200) {
                    this.loadData()
                }
            }
            catch(e) {
                if (e.response.status == 422) {
                    this.errors.wrong = e.response.data.errors
                }              
                else 
                if (e.response.status == 520) {
                    this.errors.send = "Ошибка при отправке ответа."
                }
                else {
                    this.errors.send = "Неизвестная ошибка при отправке ответа."
                }
            }
        },



    },
    components: {
        Loader,
        PageTitle,
        BreadCrumbs,
    }
}
</script>